// extracted by mini-css-extract-plugin
export default {"queryButton":"cCKvM _38618 _3Dqep qXm3b _20SLo _2XN97","queryButtonText":"_1LYwk _2kZNz _1Wqf2"};